import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, TouchableOpacity } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import { FormattedMessage } from '@dbk-legacy/format';
import SimpleBarChart from '../../../../../../src/components/common/simpleChart';
import { Small, Large } from '@dbk/ui-text';
import { NavigationList, NavigationListItem } from '@dbk/ui-list';
import AssetItem from '../../../../../../src/components/asset/asset-item';
import ValueHeader from '../../../../../../src/components/common/value-header';
import TableRow from '../../../../../../src/components/common/table-row';
import ScrollableLayout from '../../../../../../src/components/common/scrollable-layout';
import { Currency } from '../../../../../../src/components/common/number';
// import ListView from '../../../../../../src/components/common/list-view';
// import AssetRow from '../_asset-row';
import CalendarModal from '../../../../../../src/components/common/calendar-modal';
import styles from '../../../../../../src/screens/income-history/incomeHistoryHome/home.styles';
import SimpleDate from '../../../../../../src/components/common/date';
import Error from '../../../../../../src/components/common/error';
import { LoadingCircle } from '../../../../../../src/components/common/loading';
import SortingHeader from '../../../../../../src/components/common/sorting-header';
import DateSelectionBar from '../../../../../../src/components/common/date-selection-bar';
import format from 'date-fns/format';
import { Tab, Tabs } from '@dbk/ui-tabs';
import LayoutContainer from '../../../../../../src/components/common/layout';

class IncomeHistoryHome extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      showChart: true,
      showCalendar: false,
      timeline: 2,
      chartData: [],
      IncomeExpenseSwitch: 0,
      visibility: false,
      IncomeExpenseSummary: 0,
      selectedInteractionValue: null,
    };
    this.props.setRangeYTD();
    this.hideCalendar = this.hideCalendar.bind(this);
    this.onSelectDate = this.onSelectDate.bind(this);
    this.onIncomeExpenseSwitch = this.onIncomeExpenseSwitch.bind(this);
    this.props.getOverviewData(this.state.timeline);
    this.headerContent = this.headerContent.bind(this);
    this.handleInteractionChange = this.handleInteractionChange.bind(this);
    this.props.income.setIncomeExpenseSwitch(0);
  }

  handleInteractionChange(value) {
    this.setState({
      selectedInteractionValue: value,
    });
  }

  currentDateText(fromDate, toDate) {
    if (datesAreEqual(fromDate, toDate)) {
      return (
        <FormattedMessage
          values={{ date: fromDate }}
        />
      );
    }

    return (
      <FormattedMessage
        values={{ fromDate, toDate }}
      />
    );
  }
  openTransactionPage({ ieProdType, prodIncExp, ebLabelDesc }) {
    this.props.changePage(
      '/portfolios/income-history/transaction/' +
      ieProdType + '/' + prodIncExp + '/' + ebLabelDesc
    );
  }
  componentDidUpdate(prevProps, prevState) {
    const { income, portfolio } = this.props;
    // watch values
    if (this.props.income) {
      if (
        (income.startDate != prevProps.income.startDate) ||
        (income.endDate != prevProps.income.endDate) ||
        (portfolio.referenceCurrency != prevProps.portfolio.referenceCurrency)
      ) {
        this.props.getOverviewData(this.state.timeline);
      }
    }
  }

  componentWillUnmount() {
    this.props.clearOverviewData();
  }

  hideCalendar() {
    this.setState({
      showCalendar: false
    });
  }

  onIncomeExpenseSwitch(options) {
    const { income } = this.props;
    this.setState({ IncomeExpenseSwitch: options });
    income.setIncomeExpenseSwitch(options);
  }

  onSelectDate(options) {
    this.setState({
      timeline: options,
      showChart: false,
    });

    switch (options) {
      case 0:
        this.props.setRange7Days();
        break;
      case 1:
        this.props.setRange30Days();
        break;
      case 2:
        this.props.setRangeYTD();
        break;
      case 3:
        this.props.setRangeYTD();
        this.props.income.calendar.open();
        break;
    }

    setTimeout(() => {
      this.setState({
        showChart: true,
      });
    }, 500);
  }



  GetChartData() {
    let oReturn = {};

    switch (this.state.timeline) {
      case 0:
        oReturn = this.props.income.overviewData.week;
        break;
      case 1:
        oReturn = this.props.income.overviewData.month;
        break;
      case 2:
        oReturn = this.props.income.overviewData.year;
        break;
      case 3:

        if (this.props.income.dateDiff <= 7) {
          oReturn = this.props.income.overviewData.week;
        }
        else if (this.props.income.dateDiff > 7 && this.props.income.dateDiff <= 30) {
          oReturn = this.props.income.overviewData.month;
        } else {
          oReturn = this.props.income.overviewData.year;
        }


        break;
    }
    return oReturn;
  }


  getIESumary() {
    let oReturn = 0;
    if (this.props.income.overviewData.netIncAggregateBean != null) {
      oReturn = this.props.income.overviewData.netIncAggregateBean.netAggNetInc;
    } else {
      oReturn = 0;
    }
    return oReturn;
  }

  getSummaryAmount(TabSelection) {
    let oReturn = 0;
    let data;
    if (TabSelection == 0) {
      data = this.props.income.overviewData.totalIncBean;
    } else {
      data = this.props.income.overviewData.totalExpBean;
    }
    const dataLength = data ? data.length : 0;

    if (dataLength == 0) {
      oReturn = 0;
    } else {
      oReturn = data[0].totalIncExp;
    }
    return oReturn;
  }

  checkIncomeExpenseData(TabSelection) {
    const { i18n: { messages } } = this.props;
    const oReturn = "";
    let data;

    if (TabSelection == 0) {
      data = this.props.income.overviewData.prodIncAggregateBean;
    } else {
      data = this.props.income.overviewData.prodExpAggregateBean;
    }

    const dataCount = data ? data.length : 0;

    if (dataCount <= 0) {
      return (
        <View style={styles.notice}>
          <Small>{messages['app.profile.consolidatesetup.dataRes']}</Small>
        </View>
      );
    }
  }

  headerContent() {
    const { deviceInfo, i18n: { messages }, income: { startDate, endDate } } = this.props;
    const { selectedInteractionValue } = this.state;
    let completeDate;

    if (startDate === endDate) {
      completeDate = <div> {messages['app.maturities.dateSelectionBar.currentlyShowing.singleLanguage']} <SimpleDate value={format(startDate, 'DD MMMM YYYY')} /></div>;
    } else if (startDate != undefined && startDate.length != 0 && endDate != undefined && endDate.length != 0) {
      completeDate = <div> {messages['app.maturities.dateSelectionBar.currentlyShowing.multipleLanguage']} <SimpleDate value={format(startDate, 'DD MMMM YYYY')} /> {messages['app.common.to']} <SimpleDate value={format(endDate, 'DD MMMM YYYY')} /></div>;
    }

    return (

      <View style={styles.tabletView}>

        <CalendarModal thisYearOnly calendarModal={this.props.income.calendar} messages={messages} />
        <View style={styles.timeline}>
          <Tabs
            stretch
            secondary
            handleSelectedIndex={this.onSelectDate}
            selectedIndex={this.state.timeline} >
            <Tab testID="tab_netIncome_7days_home_test" style={{ fontSize: 16 }} renderLabel={() => messages['app.incomehistory.7days']} />
            <Tab testID="tab_netIncome_28days_home_test" style={{ fontSize: 16 }} renderLabel={() => messages['app.incomehistory.28days']} />
            <Tab testID="tab_netIncome_ytd_home_test" style={{ fontSize: 16 }} renderLabel={() => messages['app.incomehistory.ytd']} />
          </Tabs>
        </View>
        <View style={styles.DateSelectionBar}>
          <DateSelectionBar
            text={completeDate}
            isEditable={(this.state.timeline == 3)}
            onEditPress={() => this.props.income.calendar.open()} messages={messages} />
        </View>
        <View id="text_netIncome_valueHeader_home_test" style={styles.valueheader}>
          <ValueHeader
            title={messages['app.common.title.newIncome']}
            value={this.getIESumary()}
            valueUnit={this.props.portfolio.referenceCurrency} />
        </View>
        <View style={styles.chart}>
          {this.state.showChart && this.props.income.displayChart.length ?
            <SimpleBarChart
              bars={this.props.income.displayChart}
              isTablet={deviceInfo.isTablet}
              selectedInteractionValue={selectedInteractionValue}
              onInteractionChange={this.handleInteractionChange}
              messages={messages}
            /> : <View />
          }
        </View>
      </View>
    );
  }

  stickyHeaderContent() {
    const { deviceInfo, i18n: { messages } } = this.props;
    return (
      <View>
        <View style={styles.groupSelection}>
          <Tabs
            stretch
            secondary
            handleSelectedIndex={this.onIncomeExpenseSwitch}
            selectedIndex={this.state.IncomeExpenseSwitch} >
            <Tab testID="tab_netIncome_income_home_test" style={{ fontSize: 16 }} renderLabel={() => messages['app.incomehistory.income']} />
            <Tab testID="tab_netIncome_expenses_home_test" style={{ fontSize: 16 }} renderLabel={() => messages['app.incomehistory.expense']} />
          </Tabs>
        </View>
        <SortingHeader
          enabled={false}
          showBorder={false}
          messages={messages}
          currency={this.props.portfolio.referenceCurrency}
          options={[
            { key: 'type', label: 'app.report.transactionHistory.type', width: 1, isPhone: true, isTablet: true },
            { key: 'Amount', label: 'app.report.transactionHistory.amount', displayCurrency: true, width: 1, isPhone: true, isTablet: true },
          ]}
        />
      </View>
    );

  }

  bodyContent() {
    const {
      i18n: { messages },
      income: {
        overviewData: { prodExpAggregateBean, prodIncAggregateBean }
      }
    } = this.props;
    const listData = this.state.IncomeExpenseSwitch ? prodExpAggregateBean : prodIncAggregateBean
    if(listData && listData.length > 0) {
      listData.sort((prev, curr) => {
        const nameA = prev.ieProdType.toUpperCase(); // ignore upper and lowercase
        const nameB = curr.ieProdType.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        // names must be equal
        return 0;
      });
    }
    return (
      <View style={styles.container}>
        <NavigationList>
          {listData && listData.map((listElem, i) => (
            <NavigationListItem>
              <TouchableOpacity
                onPress={() => this.openTransactionPage(listElem)}
                style={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <View style={{ display: 'flex' }} id={"text_incomeHistory_home_test_"+i}>
                  <Large secondary>{listElem.ebLabelDesc}</Large>
                </View>
                <View style={{ display: 'flex' }}>
                  <Currency
                    renderProps={{ size: 'large', testID: 'header', style: { color: '#fff' } }}
                    value={listElem.prodIncExp}
                  />
                </View>
              </TouchableOpacity>
            </NavigationListItem>
          )
          )}
        </NavigationList>
        {this.checkIncomeExpenseData(this.state.IncomeExpenseSwitch)}
        <AssetItem>
          <TableRow style={styles.rowTopBorder}>
            <TableRow.Column align="left">
              <View style={styles.summaryText}>
                <Large secondary>
                  {messages['app.netIncome.totalVal']}{this.state.IncomeExpenseSwitch ? messages['app.netIncome.expenseDesc'] : messages['app.incomehistory.incomeDesc']}
                </Large>
              </View>
            </TableRow.Column>
            <TableRow.Column align="right">
              <View id="text_netIncome_currency_home_test" style={styles.rowSummary}>
                <Currency
                  renderProps={{ size: 'header3', testID: 'header', }}
                  value={this.getSummaryAmount(this.state.IncomeExpenseSwitch)} />
              </View>
            </TableRow.Column>
          </TableRow>
        </AssetItem>
      </View>
    );
  }

  render() {
    const { i18n: { messages } } = this.props;
    if (!this.props.income.overviewData) {
      return <View />;
    }
    const header = this.headerContent();
    const stickyHeader = this.stickyHeaderContent();
    const bodyContent = this.bodyContent();
    return <LayoutContainer title={messages['app.common.title.newIncome']}>
      <ScrollableLayout
        body={
          <div className="row">
            <div className="columns large-6">
              {header}
            </div>
            <div className="columns large-6">
              <div className="columns">
                {stickyHeader}
              </div>
              <div className="columns">
                {bodyContent}
              </div>
            </div>
          </div>
        }
      /> </LayoutContainer>
  }
}


IncomeHistoryHome.propTypes = {
  getData: PropTypes.func,

};


export default createContainer({

  $renderError: () => <Error />,
  $renderLoading: () => <LoadingCircle isPage />,
  $queries: {
    app: {
      global: {
        deviceInfo: {
          isTablet: true,
          width: true,
          height: true,
        }
      }
    },
    i18n: {
      messages: true,
    },
    clearOverviewData: {
      $call: 'income.clearOverviewData'
    },
    getOverviewData: {
      $call: 'income.overview'
    },
    setRange7Days: {
      $call: 'income.setRange7Days'
    },
    setRange30Days: {
      $call: 'income.setRange30Days'
    },
    setRangeYTD: {
      $call: 'income.setRangeYTD'
    },
    portfolio: {
      referenceCurrency: true,
    },
    income: {
      overviewData: true,
      startDate: true,
      endDate: true,
      dateDiff: true,
      dateDisplay: true,
      displayChart: true,
      incomeExpenseSwitch: true,
      setIncomeExpenseSwitch: {
        $set: 'incomeExpenseSwitch',
      },
      calendar: {
        open: {
          $call: 'open'
        },
        ...CalendarModal.getFragment('calendarModal'),


      }
    },
    changePage: { $call: "ui.history.push" }
  },
}, ({ app, ...queries }) => ({
  deviceInfo: app.global.deviceInfo,
  ...queries,
}))(IncomeHistoryHome);
